var render = function render(){var _vm=this,_c=_vm._self._c;return _c('confirm-dialog',{ref:"confirmDialog",attrs:{"prevent-close":true,"footer-btn-list":_vm.btnList},on:{"onYes":_vm.onYes,"onNo":_vm.onNo}})
}
var staticRenderFns = []

export { render, staticRenderFns }